<template>
  <div
    class="modal fade"
    tabindex="-1"
    ref="newTargetModalRef"
    id="update-answer-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered mw-850px h-500px">
      <div class="modal-content rounded">
        <div class="modal-header">
          <h5 class="modal-title">{{ translate("edit_answer") }}</h5>
          <a
            class="btn btn-icon btn-sm btn-active-light-primary text-dark"
            aria-label="Close"
            @click="closeModal"
          >
            <i class="bi bi-x-lg"></i>
          </a>
        </div>

        <div
          class="modal-body rounded"
          style="background: #fbfbfb"
        >
          <BlockUI
            :loading="block"
            class="position-relative"
          />
          <!-- ? Question Text -->
          <div
            class="d-flex justify-content-between mx-8"
            clear
          >
            <div class="my-2 fs-6 fw-bold">
              {{ question.questionText }}
            </div>
            <a
              v-if="question.required"
              :title="translate('audit_detail_required_answer')"
            >
              <i class="bi bi-exclamation-circle-fill fs-2 text-primary"></i
            ></a>
          </div>

          <!--  ! 1'Den Fazla Cevap Varsa -->
          <div
            v-if="question.answers.length > 1"
            class="px-8 py-4"
          >
            <!-- ? Answers -->
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-wrap justify-content-between">
                <div
                  v-for="answer in question.answers"
                  :key="`answer-div-${answer.id}`"
                  class="mb-2"
                >
                  <div class="form-check form-check-custom">
                    <input
                      v-model="answer.id"
                      name="answer"
                      class="form-check-input h-20px w-20px"
                      type="radio"
                      @click="visible = answer.id"
                      :id="`answer-${answer.id}`"
                      :checked="answer.selected"
                      :value="answer.id"
                    />
                    <label
                      class="form-check-label not-text-copy ms-2 me-10"
                      :for="`answer-${answer.id}`"
                    >
                      {{ answer.answerText }}
                    </label>
                  </div>
                </div>
              </div>

              <!--  ? Clear Button -->
              <button
                class="btn btn-sm btn-light-primary"
                @click="clearButton"
              >
                {{ translate("Clear") }}
              </button>
            </div>

            <!--  ? Cevap zorunlu uyarısı -->
            <transition
              name="component-fade"
              mode="out-in"
            >
              <div v-show="controllerAnswer">
                <InlineMessage class="fs-7 text-gray-800 bg-light-danger">
                  {{ translate("audit_detail_required_answer") }}
                </InlineMessage>
              </div>
            </transition>

            <!-- ? Answer Values -->
            <div
              v-for="answer in question.answers"
              :key="`answer-div-value-${answer.id}`"
            >
              <div
                v-if="answer.answerValues.length > 0 && visible === answer.id"
                class="py-2"
              >
                <h6 class="text-gray-500 fw-lighter mt-4 ps-0">
                  {{ translate("question_component_modal_multi_language_sub_answers") }}
                </h6>
                <div v-if="answer.type === 'Radio'">
                  <div
                    v-for="value in answer.answerValues"
                    :key="value.id"
                    class="mb-2"
                  >
                    <div class="form-check form-check-custom">
                      <input
                        v-model="value.selected"
                        name="value"
                        class="form-check-input h-20px w-20px"
                        type="radio"
                        :id="`role-${value.id}`"
                        value="true"
                      />
                      <label
                        class="form-check-label not-text-copy"
                        :for="`role-${value.id}`"
                      >
                        {{ value.valueText }}
                      </label>
                    </div>
                  </div>
                </div>
                <div v-if="answer.type === 'Multiple'">
                  <div
                    v-for="value in answer.answerValues"
                    :key="value.id"
                    class="mb-2"
                    style="display: block"
                  >
                    <div class="form-check form-check-custom">
                      <input
                        v-model="value.selected"
                        name="value"
                        class="form-check-input h-20px w-20px"
                        type="checkbox"
                        :id="`role-${value.id}`"
                      />
                      <label
                        class="form-check-label not-text-copy"
                        :for="`role-${value.id}`"
                      >
                        {{ value.valueText }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ? Description -->

            <h6 class="text-gray-500 fw-lighter mt-4 ps-0">
              {{ translate("question_component_answer_modal_evidence_options_notes") }}
            </h6>
            <textarea
              name="info"
              v-model="question.description"
              :placeholder="t('question_component_answer_modal_evidence_options_notes')"
              class="form-control fs-6"
            ></textarea>
          </div>

          <!-- ! 1 Adet Cevap Varsa ve Info sorusu değil ise -->
          <div
            v-else-if="question.answers.length === 1 && !answerTypeController(question.answers)"
            class="px-8 py-4"
          >
            <!-- ? Multiple Type-->
            <div v-if="question.answers[0].type === 'Multiple'">
              <div
                v-for="value in question.answers[0].answerValues"
                :key="value.id"
                class="mb-2"
              >
                <div class="form-check form-check-custom mb-2">
                  <input
                    v-model="value.selected"
                    class="form-check-input h-20px w-20px"
                    type="checkbox"
                    :id="`role-${value.id}`"
                  />
                  <label
                    class="form-check-label not-text-copy"
                    :for="`role-${value.id}`"
                  >
                    {{ value.valueText }}
                  </label>
                </div>
              </div>
            </div>

            <!--  ? Radio Type -->
            <div v-if="question.answers[0].type === 'Radio'">
              <div
                v-for="value in question.answers[0].answerValues"
                :key="value.id"
                class="mb-2"
              >
                <div class="form-check form-check-custom">
                  <input
                    v-model="value.selected"
                    name="value"
                    class="form-check-input h-20px w-20px"
                    type="radio"
                    :id="`role-${value.id}`"
                    :checked="value.selected"
                    :value="value.id"
                  />
                  <label
                    class="form-check-label not-text-copy"
                    :for="`role-${value.id}`"
                  >
                    {{ value.valueText }}
                  </label>
                </div>
              </div>

              <div :class="controllerAnswer === true ? 'justify-content-between' : 'justify-content-end'">
                <transition
                  name="component-fade"
                  mode="out-in"
                >
                  <div
                    v-show="controllerAnswer"
                    class="align-items-center"
                  >
                    <InlineMessage class="fs-7 text-gray-800 bg-light-danger">
                      {{ translate("audit_detail_required_answer") }}
                    </InlineMessage>
                  </div>
                </transition>
              </div>
            </div>

            <!--  ? Single Type -->
            <div
              v-if="question.answers[0].type === 'Single'"
              class="mb-2"
            >
              <div class="form-check form-check-custom">
                <input
                  v-model="question.answers[0].selected"
                  name="answer"
                  class="form-check-input h-20px w-20px"
                  type="checkbox"
                  :id="`answer-${question.answers[0].id}`"
                />
                <label
                  class="form-check-label not-text-copy"
                  :for="`answer-${question.answers[0].id}`"
                >
                  {{ question.answers[0].answerText }}
                </label>
              </div>
            </div>

            <!-- ? Description -->
            <h6 class="text-gray-500 fw-lighter mt-10 ps-0">
              {{ translate("question_component_answer_modal_evidence_options_notes") }}
            </h6>
            <textarea
              name="info"
              v-model="question.description"
              :placeholder="t('question_component_answer_modal_evidence_options_notes')"
              class="form-control fs-6"
            ></textarea>
          </div>

          <!--  ! 1 Adet Cevap Varsa ve Info Sorusu ise -->
          <div
            v-else-if="answerTypeController(question.answers)"
            class="px-8 py-4"
          >
            <h6 class="text-gray-500 fw-lighter mb-3">
              {{ t("question_component_button_answer") }}
            </h6>

            <!--  ? Text Type-->
            <textarea
              v-if="question.answers[0].type === 'Text'"
              class="form-control"
              v-model="question.answers[0].answerText"
              :placeholder="t('question_component_button_answer')"
            ></textarea>

            <!--  ? Signature Type-->
            <input
              v-if="question.answers[0].type === 'Signature'"
              type="text"
              :placeholder="t('user_modal_label_full_name')"
              class="form-control"
              v-model="question.answers[0].answerText"
            />

            <!--  ? Phone Type-->
            <input
              v-if="question.answers[0].type === 'Phone'"
              type="tel"
              :placeholder="t('PhoneNumber')"
              class="form-control mw-450px"
              v-model="question.answers[0].answerText"
            />

            <!--  ? Location Type-->
            <textarea
              v-if="question.answers[0].type === 'Location'"
              class="form-control"
              :placeholder="t('audit_report_summary_location')"
              v-model="question.answers[0].answerText"
            ></textarea>

            <!--  ? Date Type-->
            <input
              v-if="question.answers[0].type == 'DateTime'"
              type="date"
              class="form-control mw-450px"
              v-model="question.answers[0].answerText"
            />

            <!-- ? Cevap zorunlu uyarısı -->
            <transition
              name="component-fade"
              mode="out-in"
              class="mt-3"
            >
              <div
                v-show="controllerAnswer"
                class="align-items-center"
              >
                <InlineMessage class="fs-7 text-gray-800 bg-light-danger">
                  {{ translate("audit_detail_required_answer") }}
                </InlineMessage>
              </div>
            </transition>
          </div>

          <div class="d-flex justify-content-end">
            <a
              class="btn btn-sm btn-white mt-4 border me-2"
              @click="closeModal"
              >{{ translate("Cancel") }}</a
            >
            <a
              @click="sendAnswer(question)"
              class="btn btn-sm btn-primary mt-4"
            >
              {{ translate("Save") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { hideModal } from "@/core/helpers/dom";
import { ref, defineEmits, defineProps, watch, reactive, inject, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import InlineMessage from "primevue/inlinemessage";

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();
const props = defineProps({ id: Number });
const emit = defineEmits(["propsNull"]);
const auditId = inject("auditId");

const newTargetModalRef = ref(null);
const visible = ref(null);
const block = ref(true);
const controllerAnswer = ref(false);

const question = reactive({
  id: 0,
  description: null,
  questionText: null,
  questionInfoText: null,
  answers: [],
  checklistQuestionId: 0,
  required: false,
});

const sendQuestionObj = reactive({
  id: 0,
  answerId: 0,
  answerValueIds: [],
  description: null,
  answerText: null,
});

const closeModal = (isResponse) => {
  emit("propsNull");
  hideModal(newTargetModalRef.value);
};

watch(props, () => {
  question.answers = [];

  if (props.id != 0) {
    block.value = true;
    store.dispatch("AuditReportModule/GET_ANSWER_DETAIL", props.id).then((response) => {
      question.id = response.QuestionId;
      question.questionText = response.QuestionText;
      question.questionInfoText = response.QuestionInfoText;
      question.description = response.Description;
      question.required = response.IsRequired;
      question.checklistQuestionId = response.ChecklistQuestionId;

      if (response.Answers.length > 0) {
        response.Answers.forEach((answer) => {
          let modelAnswer = {
            id: 0,
            questionId: 0,
            answerText: null,
            type: null,
            selected: false,
            answerValues: [],
          };
          modelAnswer.id = answer.Id;
          modelAnswer.questionId = props.id;
          modelAnswer.type = answer.Type;
          modelAnswer.selected = answer.Selected;
          modelAnswer.answerValues = [];
          if (answer.Selected) {
            visible.value = answer.Id;
          }

          if (modelAnswer.type == "DateTime") {
            modelAnswer.answerText = answer.AnswerText;
            let date = new Date(answer.AnswerText);
            const yyyy = date.getFullYear();
            let mm = date.getMonth() + 1;
            let dd = date.getDate();

            if (dd < 10) dd = "0" + dd;
            if (mm < 10) mm = "0" + mm;
            let newDate = yyyy + "-" + mm + "-" + dd;

            modelAnswer.answerText = newDate;
          } else {
            modelAnswer.answerText = answer.AnswerText;
          }

          //Answer Values
          if (answer.AnswerValues.length > 0) {
            answer.AnswerValues.forEach((value) => {
              let modelValue = {
                id: 0,
                answerId: 0,
                valueText: null,
                selected: false,
              };

              modelValue.id = value.Id;
              modelValue.answerId = value.AnswerId;
              modelValue.valueText = value.ValueText;
              modelValue.selected = value.Selected;

              modelAnswer.answerValues.push(modelValue);
            });
          }
          question.answers.push(modelAnswer);
        });
      }
      block.value = false;
    });
  } else {
    block.value = false;
  }
});

const getAuditDetails = (Id) => {
  store.dispatch("AuditReportModule/GET_REPORT_DETAILS", Id);
};

const sendAnswer = (question) => {
  sendQuestionObj.id = props.id;
  sendQuestionObj.description = question.description;
  sendQuestionObj.answerValueIds = [];

  const answers = question.answers;

  //  Cevap sayısı 1'den fazla  ise
  if (answers.length > 1) {
    let selectedAnswerId = 0;
    let selectedAnswerValues = [];

    answers.forEach((answer) => {
      //Checked olan cevanbın idsini alındı
      let checkedAnswer = document.getElementById(`answer-${answer.id}`).checked;
      if (checkedAnswer) {
        selectedAnswerId = answer.id;

        //Alt cevaplardan seçili olanın idsini alındı
        if (answer.answerValues.length > 0) {
          answer.answerValues.forEach((item) => {
            let checkedAnswerValue = document.getElementById(`role-${item.id}`).checked;
            if (checkedAnswerValue) {
              selectedAnswerValues.push(item.id);
            }
          });
        }
      } else {
        return;
      }
    });

    sendQuestionObj.answerId = selectedAnswerId;
    sendQuestionObj.answerValues = selectedAnswerValues;
  }

  //Cevap sayısı 1 ise
  if (answers.length == 1) {
    const answerValue0 = answers[0].answerValues;
    sendQuestionObj.answerId = answers[0].id;

    //info ise
    if (answerTypeController(answers)) {
      sendQuestionObj.answerText = answers[0].answerText;
    }

    //info değil ise
    else {
      if (answerValue0.length > 0) {
        answerValue0.forEach((item) => {
          const checkedAnswerValue = document.getElementById(`role-${item.id}`).checked;
          if (checkedAnswerValue) {
            sendQuestionObj.answerValueIds.push(item.id);
          }
        });
      }
    }
  }

  let emptyControl = sendQuestionObj.answerText == "" || sendQuestionObj.answerId == 0;

  if (question.required && emptyControl) {
    controllerAnswer.value = true;

    setTimeout(() => {
      controllerAnswer.value = false;
    }, 2000);
  } else {
    store.dispatch("AuditReportModule/UPDATE_ANSWER", sendQuestionObj).then((response) => {
      if (response) {
        getAuditDetails(auditId);
      }
      closeModal(true);
    });
  }
};

const clearButton = () => {
  const answer = document.getElementsByName("answer");
  answer.forEach((item) => {
    if (item.checked) {
      item.checked = false;
    }
  });

  const answerValue = document.getElementsByName("value");
  answerValue.forEach((item) => {
    if (item.checked) {
      item.checked = false;
    }
  });
};

let typeList = ["Text", "DateTime", "Phone", "Signature", "Location"];

const answerTypeController = (questionAnswers) => {
  let status = false;
  for (let index = 0; index < questionAnswers.length; index++) {
    let answer = questionAnswers[index];
    if (!status) {
      status = typeList.some((x) => x === answer.type);
    } else break;
  }
  return status;
};

const clearForm = () => {
  setTimeout(() => {
    question.id = 0;
    question.questionText = null;
    question.questionInfoText = null;
    question.answers = [];
    question.checklistQuestionId = 0;
    question.description = null;
  }, 300);
};

onMounted(() => {
  document.getElementById("update-answer-modal").addEventListener("hide.bs.modal", function () {
    clearForm();
    emit("propsNull", true);
  });
});
</script>

<style></style>
